import { Email } from './smtp';
const creds = {
  Host: 'smtp.ionos.com',
  Username: 'cor_mailer@cityofrefugeucc.org',
  Password: 'corUcc@94621',
  From: 'cor_mailer@cityofrefugeucc.org'
};
export const regexPhone =
  '/^(?:(?:(?(?:00|+)([1-4]dd|[1-9]d?))?)?[-. \\/]?)?((?:(?d{1,})?[-. \\/]?){0,})(?:[-. \\/]?(?:#|ext.?|extension|x)[-. \\/]?(d+))?$/';
export function sendEmail(to, subj, theBody) {
  Email.send({
    Host: creds.Host,
    Username: creds.Username,
    Password: creds.Password,
    To: to,
    From: creds.From,
    Subject: subj,
    Body: theBody
  }).then(message => alert('mail sent successfully'));
}
